import * as yup from 'yup';

export const registerSchema = yup.object().shape({
  email: yup.string().email('이메일 형식이 아닙니다').required('이메일을 입력해주세요'),
  agencyType: yup.string().required('부동산 유형을 선택해주세요'),
  agencyName: yup
    .string()
    .required('부동산 이름을 입력해주세요')
    .test('korean', '한글만 입력해주세요', (value) => {
      const regex = /^[가-힣\s]+$/;
      return regex.test(value);
    }),
  agencyNameEN: yup
    .string()
    .required('부동산 이름(영문)을 입력해주세요')
    .test('korean', '영문만 입력해주세요', (value) => {
      const regex = /^[a-zA-Z\s]+$/;
      return regex.test(value);
    }),
  registrationNumber: yup
    .string()
    .when('agencyType', (agencyType, schema) =>
      agencyType[0] === 'ESTATE'
        ? schema.required('개업 공인중개사 사무소 등록번호를 입력해주세요')
        : schema.nullable(),
    ),
  address: yup.string().required('주소를 입력해주세요'),
  addressEN: yup.string().notRequired(),
  addressDetail: yup.string().required('상세 주소를 입력해주세요').typeError('상세 주소를 입력해주세요'),
  agencyPhoneNumber: yup.string().required('부동산 전화번호를 입력해주세요'),
  firstName: yup
    .string()
    .required('이름을 입력해주세요')
    .test('korean', '한글만 입력해주세요', (value) => {
      const regex = /^[가-힣]+$/;
      return regex.test(value);
    }),
  lastName: yup
    .string()
    .required('성을 입력해주세요')
    .test('korean', '한글만 입력해주세요', (value) => {
      const regex = /^[가-힣]+$/;
      return regex.test(value);
    }),
  firstNameEN: yup
    .string()
    .required('이름(영문)을 입력해주세요')
    .test('korean', '영문만 입력해주세요', (value) => {
      const regex = /^[a-zA-Z\s]+$/;
      return regex.test(value);
    }),
  lastNameEN: yup
    .string()
    .required('성(영문)을 입력해주세요')
    .test('korean', '영문만 입력해주세요', (value) => {
      const regex = /^[a-zA-Z\s]+$/;
      return regex.test(value);
    }),
  phoneNumber: yup.string().required('전화번호를 입력해주세요'),

  adminManagerInfos: yup
    .array()
    .of(
      yup.object().shape({
        adminManagerName: yup.string().trim().required('이름을 입력해주세요'),
        adminManagerPhoneNumber: yup
          .string()
          .trim()
          .matches(/^[0-9]+$/, '연락처를 입력해주세요')
          .required('연락처를 입력해주세요'),
      }),
    )
    .notRequired(),

  languages: yup.array().notRequired(),
  mainListings: yup.array().notRequired(),
  password: yup
    .string()
    .required('비밀번호를 입력해주세요')
    .min(8, '비밀번호는 최소 8자 이상이어야 합니다')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      '비밀번호는 소문자, 대문자, 숫자를 각각 하나 이상 포함해야 합니다',
    ),
  passwordConfirm: yup
    .string()
    .required('비밀번호 확인을 입력해주세요')
    .oneOf([yup.ref('password')], '비밀번호가 일치하지 않습니다'),
});
